import { render, staticRenderFns } from "./ProjectArchives.vue?vue&type=template&id=32088f52&"
import script from "./ProjectArchives.vue?vue&type=script&lang=js&"
export * from "./ProjectArchives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32088f52')) {
      api.createRecord('32088f52', component.options)
    } else {
      api.reload('32088f52', component.options)
    }
    module.hot.accept("./ProjectArchives.vue?vue&type=template&id=32088f52&", function () {
      api.rerender('32088f52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/projects/ProjectArchives.vue"
export default component.exports